// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2066":"168b9ebc9d5f4618","5241":"e66005802272cc09","9927":"d468f2b77ae9f809"}[chunkId] + ".css";
};